import {Props_Timeline} from "./Timeline.props";
import {CompileMarkdown} from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import { SwiperPagination, swiperPaginationOptions } from '../Shared/SwiperControls/SwiperControls'
import { useState, useEffect, useRef } from 'react'

export const Timeline = (props: Props_Timeline) => {
    const {heading, text, repeatable_items, background} = props;
    const [shouldUseSwiper, setShouldUseSwiper] = useState(false)
    const carouselId = "timeline-carousel"
    const timelineContainerRef = useRef<HTMLDivElement>(null)
    
    const backgroundMap = {
        'default': '#f1f8e9',
        'covea-dark-blue': '#122147',
        'covea-light-green': '#d6eac1',
        'covea-light-red': '#efded3',
        'covea-light-purple': '#e2d3f2',
        'covea-light-turquoise': '#c8eaed',
        'covea-light-yellow': '#eae8ad',
        'MAAF-dark-blue': '#0091a7',
        'MAAF-light-blue': '#e5f3f5',
        'MAAF-light-red': '#fef6f2',
        'MMA-light-green': '#d6eceb',
        'MMA-light-orange': '#f2e1b5',
        'MMA-dark-blue': '#1d3b6d',
        'GMF-dark-blue': '#144390',
        'GMF-light-blue': '#dfedff',
        'GMF-light-orange': '#fff4ed',
        'Fidelia-dark-green': '#269b38',
        'Fidelia-light-blue': '#e1f0fb',
        'Fidelia-light-green': '#ebf2e7'
    }

    const backgroundKey = (typeof background?.colour?.value === 'string' ? background.colour.value : 'default')
    const backgroundValue = backgroundMap[backgroundKey as keyof typeof backgroundMap]
    const darkBackgrounds = ['covea-dark-blue', 'MAAF-dark-blue', 'MMA-dark-blue', 'GMF-dark-blue', 'Fidelia-dark-green']
    const useWhiteText = darkBackgrounds.includes(backgroundKey) ? 'timeline--white-text' : ''
    
    useEffect(()=>{

        const container = timelineContainerRef.current;
        const itemCount = repeatable_items?.length || 0;
        
        console.log(itemCount)

        if (container) {
            (container as HTMLElement).style.setProperty('--timeline-columns', itemCount.toString());
        }
        const checkSwiperCondition = () => {
            const screenWidth = window.innerWidth
            const hasMoreThan5Items = repeatable_items && repeatable_items.length > 5
            setShouldUseSwiper(screenWidth < 990 || hasMoreThan5Items)
        }
        checkSwiperCondition()
        window.addEventListener('resize', checkSwiperCondition)
        
        return () => window.removeEventListener('resize', checkSwiperCondition)
    }, [repeatable_items])
    
    return (
        <section className={`timeline ${useWhiteText}`} style={{backgroundColor: backgroundValue}}>
            <div className={`timeline__container`}>
                {heading?.content?.value &&
                    <h2 className={`timeline__heading`}>
                        {heading.content.value}
                    </h2>
                }
                
                    <div className={`timeline__text`}>
                        {text?.content?.value && CompileMarkdown(text.content.value as string)}
                    </div>
                
                {repeatable_items?.length > 0 && (
                    <>
                        {shouldUseSwiper ? (
                            <div className="timeline__swiper-container">
                                {/*<SwiperNavigation uniqueId={carouselId} className="timeline__navigation" />*/}
                                <Swiper
                                    className="timeline__items"
                                    modules={[Navigation, Pagination, A11y]}
                                    a11y={{
                                        prevSlideMessage: `{{js.swiper.carousel.navigation.button.previous.aria-label}}`,
                                        nextSlideMessage: `{{js.swiper.carousel.navigation.button.next.aria-label}}`,
                                    }}
                                    navigation={{
                                        prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                                        nextEl: `.swiper-navigation__button-next-${carouselId}`,
                                    }}
                                    pagination={{
                                        ...swiperPaginationOptions,
                                        el: `.swiper-pagination-${carouselId}`,
                                    }}
                                    slidesPerView={1}
                                    spaceBetween={20}
                                    breakpoints={{
                                        480: {
                                            slidesPerView: 2,
                                            spaceBetween: 0,
                                        },
                                        768: {
                                            slidesPerView: 3,
                                            spaceBetween: 0,
                                        },
                                        990: {
                                            slidesPerView: 4,
                                            spaceBetween: 0,
                                        },
                                    }}
                                >
                                    {repeatable_items.map((item, index) => (
                                        <SwiperSlide key={index} className={`timeline__item`}>
                                            <div className={`timeline__item-inner`}>
                                                {item.date?.value &&
                                                    <div className={`timeline__item-date`}>
                                                        <h3>{item.date.value}</h3>
                                                    </div>
                                                }
                                                {item.content?.value &&
                                                    <div className={`timeline__item-content`}>
                                                        {CompileMarkdown(item.content.value as string)}
                                                    </div>
                                                }
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                <SwiperPagination uniqueId={carouselId} className="timeline__pagination" />
                            </div>
                        ) : (
                            <div ref={timelineContainerRef} className={`timeline__timeline-container`}>
                                {repeatable_items?.map((item, index) => (
                                    <div key={index} className={`timeline__item`}>
                                        <div className={`timeline__item-inner`}>
                                            {item.date?.value &&
                                                <div className={`timeline__item-date`}>
                                                    <h3>{item.date.value}</h3>
                                                </div>
                                            }
                                            {item.content?.value &&
                                                <div className={`timeline__item-content`}>
                                                    {CompileMarkdown(item.content.value as string)}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
            </div>
        </section>
    )
}

export default Timeline;